import URI from 'urijs';
import { appQueryParameters } from '@clubmed/utils';
import config from 'Config/index';
import { IFRAME_CALLBACK_URL, SELLER_CALLBACK_URL } from 'Routes/constants';

import { isFeatureFlipped } from 'Utils/feature-flipping/featureFlippingUtils';
import { PAYMENT_ID_WECHAT } from './constants';
const DEFAULT_CALLBACK_PATH = '/pr';
const DEFAULT_CANCEL_CALLBACK_PATH = `${DEFAULT_CALLBACK_PATH}/cancel`;
const POLLING_CALLBACK_PATH = '/payment-notification';
const POLLING_PROVIDERS = [PAYMENT_ID_WECHAT];
const SHORTENED_LOCALE_QUERY_PARAM = 'l';
const SHORTENED_PROPOSAL_ID_QUERY_PARAM = 'spi';
const VOXPAY_PROVIDER_PREFIX = 'EVOXPAY';

function getCallbackURIFromProvider(
  providerId: string,
  proposalId: string,
  appContext: AppContext,
  location: URI,
): string {
  const callbackPath =
    POLLING_PROVIDERS.indexOf(providerId) !== -1 ? POLLING_CALLBACK_PATH : DEFAULT_CALLBACK_PATH;
  const callbackUri = location
    .clone()
    .path(callbackPath)
    .query('')
    .setQuery(
      URI.parseQuery(location.query()).hasOwnProperty(appQueryParameters.legacy.be)
        ? appQueryParameters.legacy.be
        : null,
    )
    .setQuery(SHORTENED_LOCALE_QUERY_PARAM, appContext.locale)
    .setQuery('isCmta', appContext.isCmta ? 'true' : 'false');

  if (providerId.startsWith(VOXPAY_PROVIDER_PREFIX)) {
    callbackUri.setQuery(SHORTENED_PROPOSAL_ID_QUERY_PARAM, proposalId);
  }

  return callbackUri.toString();
}

function getCancelCallbackURI(appContext: AppContext, uri: URI): string {
  return uri
    .path(DEFAULT_CANCEL_CALLBACK_PATH)
    .query('')
    .setQuery(SHORTENED_LOCALE_QUERY_PARAM, appContext.locale)
    .toString();
}

function shouldApprovePayment(providerId: string): boolean {
  return !!config.get(`psp.${providerId.toLowerCase()}.approve`);
}

function isHostedFieldsPayment(providerId: string): boolean {
  return !!config.get(`psp.${providerId.toLowerCase()}.hosted_fields`);
}

function isIframePayment(providerId: string, appContext: AppContext): boolean {
  return isFeatureFlipped(appContext)(`psp.iframe.${providerId.toLowerCase()}`);
}

function getIframeCallbackUrl(location: URI): string {
  return location.clone().path(IFRAME_CALLBACK_URL).query('').toString();
}

function getCallbackUrlSeller(location: URI): string {
  return location.clone().path(SELLER_CALLBACK_URL).query('').toString();
}

export {
  getCallbackURIFromProvider,
  getCallbackUrlSeller,
  isHostedFieldsPayment,
  isIframePayment,
  getIframeCallbackUrl,
  getCancelCallbackURI,
  shouldApprovePayment,
};
